import clsx from 'clsx'
import { formatMoney } from '../../../helpers/currency-formatter'

interface PriceProps {
  price: string
  compareAtPrice?: string
  className?: string
}

export function Price({ price, compareAtPrice, className }: PriceProps) {
  const isOnSale = parseFloat(price) < parseFloat(compareAtPrice || '0')

  const moneyFormat = window.globals?.shopify?.moneyFormat || '${{amount}}'

  const formatPrice = (value: string) => {
    if (!value) return ''

    const priceInCents = Math.round(parseFloat(value) * 100)

    return formatMoney(priceInCents, moneyFormat)
  }

  return (
    <p className={clsx(className)}>
      {!isOnSale ? null : <span className="paragraph-s line-through">{formatPrice(compareAtPrice || '')}</span>}

      <span className={clsx('paragraph-s', isOnSale ? 'text-brand-sale' : '')}>{formatPrice(price)}</span>
    </p>
  )
}
